/**
 * WelcomeSection - New template design for first-time users
 * Features:
 * - "Ready to Challenge Yourself?" hero headline
 * - 3 horizontal gradient step icons with connecting lines
 * - Green tagline
 * - Single pill CTA button
 */

import { StepIconsRow } from "./StepIconsRow";

export function WelcomeSection() {
  return (
    <div className="relative flex flex-col">
      {/* Ambient Glow Effect */}
      <div className="welcome-ambient-glow" />

      {/* Content Container */}
      <div className="relative z-10 flex flex-col gap-6 pt-2 pb-4">
        {/* Hero Headline - Center aligned */}
        <div className="px-5 text-center">
          <h1 className="text-[25px] font-semibold leading-[111.5%] text-slate-900 dark:text-white font-dm-sans">
            Ready to Challenge
            <br />
            Yourself?
          </h1>
        </div>

        {/* Step Icons Row */}
        <StepIconsRow />

        {/* Tagline */}
        <p className="text-center text-[13px] font-semibold text-[#059669] dark:text-[#20f219] tracking-tight font-dm-sans">
          Commit. Compete. Conquer. Cash in
        </p>
      </div>
    </div>
  );
}

/**
 * CreateChallengePill - Standalone pill CTA button
 * Separated to allow flexible placement in the layout
 */
interface CreateChallengePillProps {
  onClick: () => void;
}

export function CreateChallengePill({ onClick }: CreateChallengePillProps) {
  return (
    <div className="flex justify-center px-6 py-5">
      <button
        onClick={onClick}
        className="px-8 py-3 bg-primary-dark dark:bg-primary border border-black/10 dark:border-white/10 rounded-full text-white dark:text-black text-sm font-semibold font-dm-sans hover:brightness-110 transition-all active:scale-[0.98]"
      >
        Create your own challenge !
      </button>
    </div>
  );
}
